import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import VinWonderTicket from './../models/VinWonderTicket';
import VinWonderTicketItems from './../models/VinWonderTicketItems';

const initialState = {
    isFetching: false,
    isFetched: false,
    vinWonderTickets: [],
    listRefs: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        vinWonderTicket: new VinWonderTicket()
    },
    detailItem: new VinWonderTicketItems()
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.VIN_WONDER_TICKET_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_TICKET_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                vinWonderTickets: action.vinWonderTickets.result,
                pageSize: action.vinWonderTickets.pageSize,
                pageIndex: action.vinWonderTickets.pageIndex,
                totalCount: action.vinWonderTickets.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.VIN_WONDER_TICKET_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, vinWonderTickets: [] };
        case Types.VIN_WONDER_TICKET_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.VIN_WONDER_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    vinWonderTicket: action.vinWonderTicket
                }
            };
        case Types.VIN_WONDER_TICKET_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.VIN_WONDER_TICKET_ITEM_DETAIL_ACTION:
            return { ...state, isFetching: true, detailItem: initialState.detailItem };
        case Types.VIN_WONDER_TICKET_ITEM_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detailItem: action.vinWonderTicketItem
            };
        case Types.VIN_WONDER_TICKET_ITEM_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.VIN_WONDER_TICKET_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_TICKET_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_TICKET_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_GET_ALL_REF:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_GET_ALL_REF_SUCCESS:
            return {
                ...state,
                isFetching: false, 
                isFetched: true,
                listRefs: action.listRefs
            };
        case Types.VIN_WONDER_TICKET_ITEM_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.VIN_WONDER_TICKET_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_TICKET_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_TICKET_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_TICKET_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_TICKET_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.VIN_WONDER_TICKET_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.VIN_WONDER_TICKET_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default: 
            return state
    }
}
